import { groupChannelTypeList } from "../constants";
import {
  ChatListType,
  ConversationListByType,
  LastMessageType,
} from "../types";
import { ConversationTypeEnum } from "../types/enums";

export const getInfoByType = (chat: ChatListType): ChatListType => {
  switch (chat.type) {
    case ConversationTypeEnum.GROUP:
    case ConversationTypeEnum.CHANNEL:
      return {
        ...chat,
        chatId: chat?._id,
        chatName: chat?.name,
        lastMessage: chat?.lastMessage ?? ({} as LastMessageType),
        user: {
          id: chat?._id,
          username: chat.name ?? "",
          photoFile: chat?.photoFile ?? "",
          isOnline: false,
        },
      };
    default:
      return {
        ...chat,
        chatName: chat?.user?.username,
      };
  }
};
export const getUserId = (chat: ChatListType) => {
  let id = chat?.user?.id ?? 0;
  if (!id && chat.chatId.split("-")[0] === chat.chatId.split("-")[1])
    id = +chat.chatId.split("-")[0];
  return +id;
};

export const checkIsMine = (chat: ChatListType) => {
  return chat.chatId.split("-")[0] === chat.chatId.split("-")[1];
};

export const lastMessageTime = (time: string | Date) => {
  const localTime = new Date(time);
  return localTime?.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const generateChatId = (senderId: number, receiverId: number) => {
  const chatId = [senderId, receiverId].sort((a, b) => a - b).join("-");
  return chatId;
};

export const getChatPartnerId = (
  userInfoId: number,
  senderId: number,
  receiverId: number
): number => {
  return senderId === userInfoId ? receiverId : senderId;
};

export const checkIsMuted = () => {
  const storedValue = localStorage.getItem("chatMute") ?? "false";
  return storedValue === "true";
};
export const toggleMuteNotif = () => {
  const storedValue = localStorage.getItem("chatMute") ?? "false";
  const newValue = storedValue === "true" ? "false" : "true";
  localStorage.setItem("chatMute", newValue);
};

export const getConversationListByType = (
  conversationList: ChatListType[]
): ConversationListByType => {
  return conversationList.reduce((acc, conversation) => {
    const type = conversation.type as ConversationTypeEnum;
    if (!acc[type]) {
      acc[type] = [];
    }
    groupChannelTypeList.includes(type)
      ? acc[type].push({
          ...conversation,
          chatId: conversation._id,
        })
      : acc[type].push(conversation);

    return acc;
  }, {} as ConversationListByType);
};

export const hasUrl = (text: string) => {
  const urlAtStartRegex = /^(https?:\/\/|www\.|[a-z0-9-]+\.[a-z]{2,})/i;
  return urlAtStartRegex.test(text.trim());
};
